import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default class Chessboard extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  render() {
    const { children, deeplinkId } = this.props;
    let rows = [];
    if (children.length > 1) {
      // MAZDAHWS-660 moves top entries to the beginning
      const sortedChildren = children.reduce((sortedChildren, key, index) => {
        if (key.props.entry.isTop) {
          sortedChildren.unshift(key);
        } else {
          sortedChildren.push(key);
        }
        return sortedChildren;
      }, []);

      // creates chessboard rows consisting of two chessboard items
      let add = 0;
      rows = sortedChildren.reduce((rows, key, index) => {
        // If the item type is an image, it will solely fill that row without any other item
        if (key.props.entry.image) {
          add++;
        }
        if ((index + add) % 2 === 0 || key.props.entry.image) {
          rows.push([key]);
        } else {
          rows[rows.length - 1].push(key);
        }
        return rows;
      }, []);
    }

    return (
      <div className={cx('chessboard', { white: this.props.white })} id={deeplinkId}>
        {rows.length > 1 &&
          rows.map((items, i) => (
            <div key={i} className={styles.row}>
              {items.map((item) => item)}
            </div>
          ))}
        {rows.length < 1 && children && <div className={styles.row}>{children}</div>}
      </div>
    );
  }
}
